
import * as types from './mutations_types.js';

export default {
	update_areaOption: ({
		commit
	}, 
		data
	) => {
		return new Promise((resolve, reject) => {
			commit(types.update_areaOption, 
				data
			);
			resolve()
		});
	},

	update_scoreItem: ({
		commit
	}, 
		data
	) => {
		return new Promise((resolve, reject) => {
			commit(types.update_scoreItem, 
				data
			);
			resolve()
		});
	},

  update_subDomain: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_subDomain,
        data
      );
      resolve()
    });
  },





	
};